
import { Record, RecordEntry } from "@/shogi";
import { computed, ref, defineComponent, Ref } from "vue";
import ButtonIcon from "@/components/primitive/ButtonIcon.vue";

export default defineComponent({
  name: "RecordView",
  components: {
    ButtonIcon,
  },
  props: {
    record: {
      type: Record,
      required: true,
    },
    operational: {
      type: Boolean,
      required: false,
    },
  },
  emits: [
    "goBegin",
    "goBack",
    "goForward",
    "goEnd",
    "selectMove",
    "selectBranch",
  ],
  setup(props, context) {
    const moveList: Ref = ref(null);
    const branchList: Ref = ref(null);

    const goBegin = () => {
      context.emit("goBegin");
    };

    const goBack = () => {
      context.emit("goBack");
    };

    const goForward = () => {
      context.emit("goForward");
    };

    const goEnd = () => {
      context.emit("goEnd");
    };

    const changeNumber = () => {
      context.emit("selectMove", Number(moveList.value.value));
    };

    const changeBranch = () => {
      context.emit("selectBranch", Number(branchList.value.value));
    };

    const beginPosSelected = computed(() => props.record.current.number === 0);

    const moves = computed(() => {
      const ret: {
        text: string;
        number: number;
        hasBranch: boolean;
        selected: boolean;
      }[] = [];
      props.record.moves.forEach((elem) => {
        ret.push({
          number: elem.number,
          text: elem.displayText,
          hasBranch: elem.hasBranch,
          selected: elem === props.record.current,
        });
      });
      return ret;
    });

    const branches = computed(() => {
      if (!props.record.branchBegin.branch) {
        return null;
      }
      const ret: {
        index: number;
        text: string;
        selected: boolean;
      }[] = [];
      let p: RecordEntry | null;
      for (p = props.record.branchBegin; p && p.move; p = p.branch) {
        ret.push({
          index: ret.length,
          text: p.displayMoveText,
          selected: p.activeBranch,
        });
      }
      return ret;
    });

    return {
      beginPosSelected,
      moves,
      branches,
      moveList,
      branchList,
      goBegin,
      goBack,
      goForward,
      goEnd,
      changeNumber,
      changeBranch,
    };
  },
});
